/* eslint-disable react-hooks/exhaustive-deps */
import { useRef } from "react";
import Header from "../../../components/common/layout/Header";
import about1 from "../../../assets/images/about7.png"
import about2 from "../../../assets/images/about8.png"
import about3 from "../../../assets/images/about9.png"
import about4 from "../../../assets/images/about4.jpg"
import about5 from "../../../assets/images/about5.jpg"
import about6 from "../../../assets/images/about6.jpg"

import Slider from "react-slick";
import { AboutSvg1, AboutSvg2, AboutSvg3, AboutSvg4, AboutSvg5, AboutSvg6, Next, Prev } from "../../../components/common/svg/AllSvg";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Canonical from "../../../components/common/layout/Canonical";

const AboutUs = ({ type }: any) => {
    const { t } = useTranslation('common');
    // const lang: string = useSelector((state: any) => state.ui.lang);
    // const [line, setLine] = useState<any>(null)
    const arrowRef: any = useRef(null);
    const data: any[] = [about1, about2, about3, about4, about5, about6]

    const settings = {
        dots: false,
        variableWidth: true,
        arrows: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    variableWidth: false,
                    infinite: true,
                }
            },
        ]
    }

    // const getLine = async () => {
    //     try {
    //         const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.line_list}`);

    //         if (res && res?.status === 200) {
    //             res?.data?.length > 0 && setLine(res?.data?.[0])
    //         }
    //     } catch (error) {
    //         console.error("error while feching line list", error);
    //     }
    // };

    // useEffect(() => {
    //     !!lang && getLine();
    // }, [lang])

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.about.title")}</title>
                <meta name="description" content={t("seo_friendly.about.desc")} />
            </Helmet>
            <div className='bg-white dark:bg-bgDarkDull'>
                <Header type={type} />
                <div className="py-[30px] lg:py-[60px] xlx:py-[90px] w-full overflow-hidden" id="home">
                    <div className="container w-full h-full">
                        <div className="flex w-full justify-between mb-[30px] md:mb-[40px] xlx:mb-[60px] gap-[15px] md:flex-row flex-col">
                            <div className="flex flex-col">
                                <h4 className="text-primary font-semibold">{t("about.title.line1")}</h4>
                                <h4 className="text-primary font-semibold">{t("about.title.line2")}</h4>
                            </div>

                            <div className="flex flex-col">
                                <h1 className="text-blackDark dark:text-textBlackDark font-bold">{t("about.subtitle.line1")}</h1>
                                <h1 className="text-[#39AE62] font-bold">{t("about.subtitle.line2")}</h1>
                            </div>
                        </div>

                        <Slider className='h-full flex w-[100vw]' ref={arrowRef} {...settings}>
                            {Array.isArray(data) && data?.map((item: any, index: number) => (
                                <div className="pr-[15px] xlx:pr-[20px]" key={index}>
                                    <div className="w-full xsm:w-[450px] h-[250px] xlx:w-[490px] xlx:h-[300px] rounded-[20px]">
                                        <img src={item} alt={`about${index + 1}`} className="rounded-[20px] w-full h-full" />
                                    </div>
                                </div>
                            ))}
                        </Slider>

                        <div className="flex items-center gap-[8px] justify-end w-full mt-[30px]">
                            <button aria-label={t("aria_label.prev_arr")}
                                title={t("aria_label.prev")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:bg-opacity-[0.2] dark:bg-[#898989] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickPrev()}>
                                <Prev className="fill-primary !w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] dark:fill-[#6294FF]" />
                            </button>
                            <button aria-label={t("aria_label.next_arr")}
                                title={t("aria_label.next")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:bg-opacity-[0.2] dark:bg-[#898989] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickNext()}>
                                <Next className="fill-primary !w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] dark:fill-[#6294FF]" />
                            </button>
                        </div>

                        <div className="mt-[30px] xlx:mt-[45px] w-full grid grid-cols-1 md:grid-cols-2 gap-y-[30px] gap-x-[100px] xlx:gap-x-[115px] md:relative h-full md:py-[25px]">
                            <div className="absolute top-0 left-0 right-0 bottom-0 hidden md:flex items-center justify-center h-full w-full">
                                <div className="w-[1px] h-full opacity-[0.2] bg-black dark:bg-white"></div>
                            </div>
                            <div className="md:block hidden"></div>
                            <div className="flex flex-col gap-[8px] xlx:gap-[10px] md:relative">
                                <h4 className="font-bold text-primaryText dark:text-white">{t("about.content1.line1")}</h4>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-justify">{t("about.content1.line2")}</h5>

                                <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full hidden md:flex items-center justify-center bg-primary absolute top-0 left-[-68px] xlx:left-[-78px]">
                                    <AboutSvg1 />
                                </div>
                            </div>
                            <div className="w-full h-full border-b border-opacity-[0.2] border-black relative flex md:hidden">
                                <div className="flex items-center justify-center absolute top-0 left-0 right-0 bottom-0">
                                    <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full flex md:hidden items-center justify-center bg-primary">
                                        <AboutSvg1 />
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col gap-[8px] xlx:gap-[10px] md:relative">
                                <h4 className="font-bold text-primaryText dark:text-white text-end">{t("about.content2.line1")}</h4>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-end">{t("about.content2.line2")}</h5>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-end">{t("about.content2.line3")}</h5>

                                <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full hidden md:flex items-center justify-center bg-secDarkRed absolute top-0 right-[-68px] xlx:right-[-78px]">
                                    <AboutSvg2 />
                                </div>
                            </div>
                            <div className="md:block hidden"></div>
                            <div className="w-full h-full border-b border-opacity-[0.2] border-black relative flex md:hidden">
                                <div className="flex items-center justify-center absolute top-0 left-0 right-0 bottom-0">
                                    <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full flex md:hidden items-center justify-center bg-secDarkRed">
                                        <AboutSvg2 />
                                    </div>
                                </div>
                            </div>

                            <div className="md:block hidden"></div>
                            <div className="flex flex-col gap-[8px] xlx:gap-[10px] md:relative">
                                <h4 className="font-bold text-primaryText dark:text-white">{t("about.content3.line1")}</h4>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-justify">{t("about.content3.line2")}</h5>

                                <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full hidden md:flex items-center justify-center bg-[#FCAB02] absolute top-0 left-[-68px] xlx:left-[-78px]">
                                    <AboutSvg3 />
                                </div>
                            </div>
                            <div className="w-full h-full border-b border-opacity-[0.2] border-black relative flex md:hidden">
                                <div className="flex items-center justify-center absolute top-0 left-0 right-0 bottom-0">
                                    <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full flex md:hidden items-center justify-center bg-[#FCAB02]">
                                        <AboutSvg3 />
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col gap-[8px] xlx:gap-[10px] md:relative">
                                <h4 className="font-bold text-primaryText dark:text-white text-end">{t("about.content4.line1")}</h4>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-end">{t("about.content4.line2")}</h5>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-end"> {t("about.content4.line3")}</h5>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-end"> {t("about.content4.line4")}</h5>

                                <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full hidden md:flex items-center justify-center bg-secPurple absolute top-0 right-[-68px] xlx:right-[-78px]">
                                    <AboutSvg4 />
                                </div>
                            </div>
                            <div className="md:block hidden"></div>
                            <div className="w-full h-full border-b border-opacity-[0.2] border-black relative flex md:hidden">
                                <div className="flex items-center justify-center absolute top-0 left-0 right-0 bottom-0">
                                    <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full flex md:hidden items-center justify-center bg-secPurple">
                                        <AboutSvg4 />
                                    </div>
                                </div>
                            </div>

                            <div className="md:block hidden"></div>
                            <div className="flex flex-col gap-[8px] xlx:gap-[10px] md:relative">
                                <h4 className="font-bold text-primaryText dark:text-white">{t("about.content5.line1")}</h4>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-justify">{t("about.content5.line2")}</h5>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-justify">{t("about.content5.line3")}</h5>

                                <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full hidden md:flex items-center justify-center bg-secOrange absolute top-0 left-[-68px] xlx:left-[-78px]">
                                    <AboutSvg5 />
                                </div>
                            </div>
                            <div className="w-full h-full border-b border-opacity-[0.2] border-black relative flex md:hidden">
                                <div className="flex items-center justify-center absolute top-0 left-0 right-0 bottom-0">
                                    <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full flex md:hidden items-center justify-center bg-secOrange">
                                        <AboutSvg5 />
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col gap-[8px] xlx:gap-[10px] md:relative">
                                <h4 className="font-bold text-primaryText dark:text-white text-end">{t("about.content6.line1")}</h4>
                                <h5 className="text-blackDull dark:text-textBlackDull font-medium text-end">{t("about.content6.line2")}</h5>

                                <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full hidden md:flex items-center justify-center bg-secGreen absolute top-0 right-[-68px] xlx:right-[-78px]">
                                    <AboutSvg6 />
                                </div>
                            </div>
                            <div className="md:block hidden"></div>
                            <div className="w-full h-full border-b border-opacity-[0.2] border-black relative flex md:hidden">
                                <div className="flex items-center justify-center absolute top-0 left-0 right-0 bottom-0">
                                    <div className="xlx:min-w-[40px] w-fit xlx:h-[40px] min-w-[35px] h-[35px] rounded-full flex md:hidden items-center justify-center bg-secGreen">
                                        <AboutSvg6 />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutUs;